export default __webpack_public_path__ + "static/media/vUsdc.05770b70.svg";